<template>
  <div
    v-click-outside="$_onClickOutside"
    ref="wsStateMultiLayer"
    class="ws-state-multi-layer round"
    :class="[
      {'is-active': menuActive},
      {'is-error': errors && errors.length},
      {'is-disabled': _disabled},
    ]"
    id="wsStateMultiLayer"
    @click.prevent="$_onToggleDropdown($event)"
  >
    <v-btn
      block
      depressed
      outlined
      height="40"
      class="
        ws-state-multi-layer__button
        d-flex justify-space-between
        rounded-lg
        py-2 px-3
      "
      :class="[{
        'textPrimary--text': _hasValue,
        'textSecondary--text': !_hasValue,
      }]"
    >
      <div
        v-if="_value.length > 0"
        class="ws-state-multi-layer__button-text text-body-2"
      >{{_valueText}}</div>
      <div
        v-else
        class="ws-state-multi-layer__placeholder text-body-2"
      >{{placeholder}}</div>
      <v-icon class="ml-1" color="textSecondary">mdi-menu-down</v-icon>
    </v-btn>
    <WsChipList
      v-if="_chipList && _chipList.length > 0"
      class="mt-1"
      :chipList="_chipList"
      @chip-close="$_onClickChipClose($event)"
    ></WsChipList>
    <div
      v-if="menuActive"
      class="
        ws-state-multi-layer__menu
        overflow-hidden
        rounded-lg
      "
      :class="{top: _isMenuOpenTopSide}"
    >
      <div
        class="ws-state-multi-layer__search-input-section pa-2"
      >
        <v-input
          hide-details
          height="40"
          class="input d-flex align-center px-2 rounded-lg"
          :class="[{'focused': isInputSearchFocused}]"
        >
          <v-icon
            slot="prepend"
            color="textSecondary"
            size="1.25rem"
          >mdi-magnify</v-icon>
          <template #default>
            <input
              v-model="searching"
              type="text"
              ref="searchInput"
              @focus="$_onSearchAction('focused')"
              @blur="$_onSearchAction"
              @keyup.enter="$_onSearch()"
            >
          </template>
          <v-icon
            slot="append"
            color="textSecondary"
            size="1.25rem"
            @click.prevent.stop="$_onClearSearch()"
          >mdi-close-circle</v-icon>
        </v-input>
      </div>
      <div
        v-if="loading"
        class="
          ws-state-multi-layer__loading-section
          d-flex align-center justify-center
        "
      >
        <v-progress-circular
          v-if="loading"
          size="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div
        v-else-if="layers.length"
        class="
          ws-state-multi-layer__layers
          overflow-auto
          pa-2
        "
      >
        <WsStateMultiLayerLayers
          v-for="(item,itemIndex) in layers"
          :key="itemIndex"
          :layers="item.layers"
          :valueKey="valueKey"
          :textKey="textKey"
          :multiple="multiple"
          :active="$_getStatus(_value, layers, item)"
          :value="$_getItemsValue(_value, item[`${valueKey}`])"
          @click-checkbox="$_onClickCheckbox($event, _value, layers, item)"
          @input="$_onItemInput($event, _value, item)"
        >{{item[`${textKey}`]}}</WsStateMultiLayerLayers>
      </div>
      <div
        v-else
        class="pa-3 text-body-2 textSecondary--text"
      >
        <p v-if="searching" class="ma-0">找不到 ”{{searching}}” 相關搜尋結果</p>
        <p v-else class="ma-0">無選項</p>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import S_multiLayer from "@/helpers/multiLayer";
export default {
  data: () => ({
    searching: "",
    isInputSearchFocused: false,
    menuActive: false,
    loading: false,
    selectButtonPositionY: 0,
    window: {
      width: 0,
      height: 0,
    },
    layers: [],
  }),
  methods: {
    $_onSearchAction(type) {
      if (type === "focused") {
        this.isInputSearchFocused = true
      } else {
        this.isInputSearchFocused = false
      }
    },
    $_onClickOutside() {
      this.menuActive = false;
    },
    async $_onToggleDropdown($event) {
      if ($event.target.id !== 'wsStateMultiLayer') return;
      if (this._disabled) {return}
      this.$_getSelectButtonPositionY();
      this.menuActive = !this.menuActive;
      if (this.menuActive) {
        await this.$_fetchData();
        this.$_handleResize();
        setTimeout(() => {
          if (!this.$refs.searchInput) return;
          this.$refs.searchInput.focus();
        }, 0);
      }
    },
    async $_fetchData(){
      if (this.loading) return;
      try {
        this.loading = true;
        const url = this.getUrl
        ? `${this.getUrl}`
        :`${this.modelName}`
        const params = {}
        if (this.conditions) {
          this.conditions.forEach((condition) => {
            if (condition.value) {
              if (condition.type === 'array') {
                params[`${condition.key}`] = ''
                condition.value.forEach((value) => {
                  params[`${condition.key}`] += `${value},`
                })
              } else if (condition.type === 'number') {
                params[`${condition.key}`] = `${condition.value}`
              }
            }
          })
        }
        if (this.searching) {
          params.search = `${this.searching}`
        }
        const res = await this.$axios(url, {params})
        let layers = this.$_setItems(res.data.data)
        this.layers = layers
      } catch (error) {
        alert(error)
      } finally {
        this.loading = false;
      }
    },
    $_setItems(datas) {
      const keys = {
        valueKey: this.valueKey,
        textKey: this.textKey,
        setLayersKey: 'layers',
      }
      if ( this.layersSetting) {
        keys.getLayersKey = this.layersSetting.requiredFieldKey
      } else {
        keys.getLayersKey = this.modelName
      }
      const layers = S_multiLayer.setItems(datas, keys)
      return layers
    },
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_getSelectButtonPositionY() {
      if (!this.$refs.wsStateMultiLayer) return;
      const selectButton =
        this.$refs.wsStateMultiLayer.getBoundingClientRect();
      this.selectButtonPositionY = selectButton.y;
    },
    $_onClickCheckbox($event, value, layers, item) {
      let _value = []
      if (this.multiple) {
        _value = value ? [...value] : []
      }
      const status = this.$_getStatus(value, layers, item)
      const targetIndex = _value.findIndex((e) => {
        return e[`${this.valueKey}`] === item[`${this.valueKey}`]
      })
      const fullValue = this.$_getFullValueFromItemValue(item);
      if (status === true) {
        _value.splice(targetIndex, 1);
      } else if (status == "-") {
        _value.splice(targetIndex, 1);
      } else {
        if (targetIndex >= 0) {
          _value.splice(targetIndex, 1);
        } else {
          _value.push(fullValue);
        }
      }
      const result = this.$_formatResultData(_value)
      this.$emit("input", result);
    },
    $_getInnerLayersValueKeys(data){
      let arr = []
      if (data.layers) {
        data.layers.forEach((_data)=>{
          arr.push(_data[`${this.valueKey}`])
          if (_data.layers && _data.layers.length > 0) {
            arr = arr.concat(this.$_getInnerLayersValueKeys(_data))
          }
        })
      }
      return arr
    },
    $_getStatus(value, layers, item) {
      if (!value) return false
      const targetValue = value.find((e) => {
        return e[`${this.valueKey}`] === item[`${this.valueKey}`];
      });
      if (!targetValue) {
        return false
      }
      if (targetValue && layers) {
        const targetItem = layers.find((e) => {
          return e[`${this.valueKey}`] === item[`${this.valueKey}`];
        })
        if (targetItem.layers) {
          if (targetValue.layers && targetValue.layers.length) {
            let allOk = 1;
            let hasOk = 0;
            targetItem.layers.forEach((item) => {
              if (
                this.$_getStatus(
                  targetValue.layers,
                  targetItem.layers,
                  item
                ) === true
              ) {
                hasOk = 1
              } else if (
                this.$_getStatus(
                  targetValue.layers,
                  targetItem.layers,
                  item
                ) === false
              ) {
                allOk = 0
              } else {
                allOk = 0
                hasOk = 1
              }
            });
            if (allOk) {
              return true;
            } else {
              if (hasOk) {
                return "-";
              } else {
                return false;
              }
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    $_getFullValueFromItemValue(item) {
      const _fullValue = {
        [`${this.valueKey}`]: item[`${this.valueKey}`],
        [`${this.textKey}`]: item[`${this.textKey}`],
        layers: [],
      };
      return _fullValue;
    },
    $_getItemsValue(value, itemId) {
      if (!value) {
        return;
      }
      const targetValue = value.find((e) => {
        return e[`${this.valueKey}`] == itemId;
      });
      if (!targetValue) {
        return;
      }
      return targetValue.layers;
    },
    $_onItemInput($event, value, item) {
      let result = {}
      if (this.multiple) {
        let _value = value ? [...value] : [];
        const targetValueIndex = _value.findIndex((e) => {
            return e[`${this.valueKey}`] == item[`${this.valueKey}`];
        });
        if (targetValueIndex < 0) {
          _value.push({
            [`${this.valueKey}`]: item[`${this.valueKey}`],
            [`${this.textKey}`]: item[`${this.textKey}`],
            layers: [],
          });
        }
        const targetValue = _value.find((e) => {
            return e[`${this.valueKey}`] == item[`${this.valueKey}`];
        });
        if (!$event  || !$event.length) {
          targetValue.layers = [];
        } else {
          targetValue.layers = $event;
        }
        result = this.$_formatResultData(_value)
      } else {
        let _value = [{
          [`${this.valueKey}`]: item[`${this.valueKey}`],
          [`${this.textKey}`]: item[`${this.textKey}`],
          layers: [],
        }];
        if (!$event  || !$event.length) {
          _value[0].layers = [];
        } else {
          _value[0].layers = $event;
        }
        result = this.$_formatResultData(_value)
      }
      this.$emit("input", result);
    },
    $_formatResultData(originalData) {
      let result = {}
      if (!originalData.length) {
        result[`${this.modelName}`] = this.multiple ? [] : null;
        if (this.layersSetting) {
          result[`${this.layersSetting.modelName}`] = [];
        }
        return result;
      }
      if (this.multiple) {
        result[`${this.modelName}`] = originalData.map(data => data[`${this.valueKey}`]);
        const arr = originalData.flatMap(data => {
          const dataInnerLayersValueKeys = this.$_getInnerLayersValueKeys(data);
          return dataInnerLayersValueKeys;
        });
        if (this.layersSetting) {
          result[`${this.layersSetting.modelName}`] = (result[`${this.layersSetting.modelName}`] || []).concat(arr);
        } else {
          result[`${this.modelName}`] = result[`${this.modelName}`].concat(arr);
        }
      } else {
        result[`${this.modelName}`] = originalData[0][`${this.valueKey}`]
        const arr = this.$_getInnerLayersValueKeys(originalData[0]);
        if (this.layersSetting) {
          result[`${this.layersSetting.modelName}`] = (result[`${this.layersSetting.modelName}`] || []).concat(arr);
        } else {
          result[`${this.modelName}`] = (result[`${this.modelName}`] || []).concat(arr);
        }
      }
      return result
    },
    $_getChipText(value) {
      let chipList = []
      value.forEach((_value) => {
        const chip = {
          [`${this.valueKey}`]: _value[`${this.valueKey}`],
          text: _value[`${this.textKey}`],
        }
        if (_value.root !== undefined) {
          chip.root = _value.root
        }
        chipList.push(chip)
        if (_value.layers) {
          chipList = chipList.concat(this.$_getChipText(_value.layers))
        }
      })
      return chipList
    },
    $_onClickChipClose($event) {
      const _value = this.$_deepCopyFunction(this._value)
      this.$_removeChip($event, _value)
      this.$_arrangeValue(_value)
      const result = this.$_formatResultData(_value)
      this.$emit("input", result)
    },
    $_removeChip($event, value) {
      if (!$event) {
        return
      }
      let targetIndex = null
      if ($event.root) {
        targetIndex = value.findIndex((e) => {
          return e[`${this.valueKey}`] == $event[`${this.valueKey}`] && e.root
        })
      } else {
        targetIndex = value.findIndex((e) => {
          return e[`${this.valueKey}`] == $event[`${this.valueKey}`] && !e.root
        })
      }
      if (targetIndex >= 0) {
        value.splice(targetIndex, 1)
      } else {
        value.forEach((_value) => {
          if (_value.layers !== undefined) {
            this.$_removeChip($event, _value.layers)
          }
        })
      }
    },
    $_arrangeValue(value) {
      if (value.length === 0) {
        return
      }
      value.forEach(valueItem => {
        if (valueItem.layers && valueItem.layers.length > 0) {
          this.$_arrangeValue(valueItem.layers)
          if (valueItem.layers.length === 0) {
            this.$_arrangeValue(value)
          }
        }
      })
    },
    $_onSearch() {
      this.layers = []
      this.$_fetchData()
    },
    $_onClearSearch() {
      this.searching = ''
    },
    $_deepCopyFunction(inputObject) {
      if (typeof inputObject !== 'object' || inputObject === null) {
        return inputObject;
      }
      const outputObject = Array.isArray(inputObject) ? [] : {};
      for (let key in inputObject) {
        const value = inputObject[key];
        outputObject[key] = this.$_deepCopyFunction(value);
      }
      return outputObject;
    }
  },
  computed: {
    _valueText() {
      if (!this.value || this.value.length === 0) {
        return 'select'
      } else {
        return "已選取"
      }
    },
    _isMenuOpenTopSide() {
      if (this.window.height - this.selectButtonPositionY < 360) {
        return true;
      } else {
        return false;
      }
    },
    _chipList() {
      if (!this.value) {
        return []
      } else {
        const chipList = this.$_getChipText(this._value)
        return chipList
      }
    },
    _value() {
      if (!this.value || (Array.isArray(this.value) && !this.value.length) || this.layers.length <= 0) {
        return []
      } else {
        let formatValues = []
        if (this.multiple) {
          const rootLayersShallowCopy = S_multiLayer.getRootLayers(this.layers, this.value, this.valueKey)
          const rootLayers = this.$_deepCopyFunction(rootLayersShallowCopy)
          rootLayers.forEach((item) => {
            const formatValue = {
              [`${this.valueKey}`]: item[`${this.valueKey}`],
              [`${this.textKey}`]: item[`${this.textKey}`],
              root: true
            }
            if (this.requiredFieldState) {
              const requiredFieldState = [...this.requiredFieldState]
              const layers = S_multiLayer.constructLayers(item.layers, requiredFieldState, this.valueKey, this.textKey)
              if (layers.length > 0) {
                formatValue.layers =layers
              }
            } else {
              const value = [...this.value]
              const layers = S_multiLayer.constructLayers(item.layers, value, this.valueKey, this.textKey)
              if (layers.length > 0) {
                formatValue.layers =layers
              }
            }
            formatValues.push(formatValue)
          })
        } else {
          const rootLayerShallowCopy = this.layers.find((layer) => layer[`${this.valueKey}`] === this.value)
          const rootLayer = this.$_deepCopyFunction(rootLayerShallowCopy)
          const formatValue = {
            [`${this.valueKey}`]: rootLayer[`${this.valueKey}`],
            [`${this.textKey}`]: rootLayer[`${this.textKey}`],
            root: true
          }
          if (this.requiredFieldState) {
            const requiredFieldState = [...this.requiredFieldState]
            const layers = S_multiLayer.constructLayers(rootLayer.layers, requiredFieldState, this.valueKey, this.textKey)
            if (layers.length > 0) {
              formatValue.layers = layers
            }
          } else {
            const layers = S_multiLayer.constructLayers(rootLayer.layers, this.value, this.valueKey, this.textKey)
            if (layers.length > 0) {
              formatValue.layers =layers
            }
          }
          formatValues.push(formatValue)
        }
        return formatValues
      }
    },
    _disabled() {
      if (this.conditions.length > 0) {
        let result = false
        this.conditions.forEach((condition) => {
          if (condition.value === null || condition.value.length === 0) {
            result =  true
          }
        })
        return result
      } else {
        return false
      }
    },
    _hasValue() {
      return Array.isArray(this.value)
        ? this.value.length > 0
        : this.value !== null || this.value !== undefined;
    }
  },
  props: {
    errors: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "select",
    },
    value: {},
    layersSetting: {
      type: Object,
    },
    textKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    requiredFieldState: {},
    getUrl: {
      type: String,
    },
    conditions: {
      type: Array,
    },
  },
  directives: {
    ClickOutside,
  },
  async mounted() {
    await this.$_fetchData();
    this.$_handleResize();
  },
};
</script>